import { useCallback, useRef, useState } from 'react'
import { CognitoUnauthorizedError } from './useCognitoUserIsAuthenticated'

export const usePasswordVerificationTray = () => {
  const [isPasswordTrayOpen, setIsPasswordTrayOpen] = useState(false)
  const onAuthenticationComplete = useRef<() => Promise<void> | undefined>(undefined)

  const openVerifyPasswordTray = useCallback((callback: () => Promise<void> | undefined) => {
    setIsPasswordTrayOpen(true)
    onAuthenticationComplete.current = callback
  }, [])

  const closeVerifyPasswordTray = useCallback(() => {
    setIsPasswordTrayOpen(false)
    onAuthenticationComplete.current = undefined
  }, [])

  const handleCognitoError = useCallback(
    (error: unknown, retryCallback: () => Promise<void> | undefined) => {
      if (error instanceof CognitoUnauthorizedError) {
        // onVerify(mfaMethod) save to .current ref
        openVerifyPasswordTray(retryCallback)
        return true
      }
      return false
    },
    [openVerifyPasswordTray]
  )

  const handleVerify = useCallback(async () => {
    const fn = onAuthenticationComplete.current
    closeVerifyPasswordTray()
    await fn?.()
  }, [closeVerifyPasswordTray])

  return {
    isPasswordTrayOpen,
    openVerifyPasswordTray,
    closeVerifyPasswordTray,
    handleCognitoError,
    handleVerify,
  }
}
